{
    "nm": "Gpay Tick",
    "ddd": 0,
    "h": 1920,
    "w": 1920,
    "meta": {
        "g": "LottieFiles AE 0.1.20",
        "tc": "#ffffff"
    },
    "layers": [
        {
            "ty": 4,
            "nm": "Tick",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        278.033,
                        227.218,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "s": [
                                20,
                                20,
                                100
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                100,
                                100,
                                100
                            ],
                            "t": 60
                        }
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 0,
                    "k": [
                        346.916,
                        346.917,
                        0
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "s": [
                                -99
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 60
                        }
                    ],
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "s": [
                                100
                            ],
                            "t": 32
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": false,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -153.033,
                                            0.588
                                        ],
                                        [
                                            -51.404,
                                            102.218
                                        ],
                                        [
                                            153.032,
                                            -102.218
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "st",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Stroke",
                            "nm": "Stroke 1",
                            "lc": 2,
                            "lj": 2,
                            "ml": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 50,
                                "ix": 5
                            },
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 3
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    278.033,
                                    227.218
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                },
                {
                    "ty": "tm",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Filter - Trim",
                    "nm": "Trim Paths 1",
                    "ix": 2,
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "o": {
                                    "x": 0.67,
                                    "y": 0
                                },
                                "i": {
                                    "x": 0.33,
                                    "y": 1
                                },
                                "s": [
                                    0
                                ],
                                "t": 31
                            },
                            {
                                "s": [
                                    100
                                ],
                                "t": 60
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "m": 1
                }
            ],
            "ind": 1,
            "parent": 4
        },
        {
            "ty": 4,
            "nm": "Glow Mask",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "td": 1,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        346.917,
                        346.917,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "s": [
                                20,
                                20,
                                100
                            ],
                            "t": 30
                        },
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                110,
                                110,
                                100
                            ],
                            "t": 60
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                95,
                                95,
                                100
                            ],
                            "t": 80
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                102,
                                102,
                                100
                            ],
                            "t": 92
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                98,
                                98,
                                100
                            ],
                            "t": 100
                        },
                        {
                            "s": [
                                100,
                                100,
                                100
                            ],
                            "t": 110
                        }
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.506,
                                "y": 0
                            },
                            "i": {
                                "x": 0.783,
                                "y": 0.496
                            },
                            "s": [
                                1099.01,
                                1187.835,
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.337,
                                "y": 0.495
                            },
                            "i": {
                                "x": 0.576,
                                "y": 1
                            },
                            "s": [
                                989.155,
                                1114.015,
                                0
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                947.01,
                                981.835,
                                0
                            ],
                            "t": 50
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "s": [
                                100
                            ],
                            "t": 32
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ],
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ],
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            346.667
                                        ],
                                        [
                                            -346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            -346.666
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1922,
                                    0.4392,
                                    0.702
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    346.916,
                                    346.917
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 2
        },
        {
            "ty": 4,
            "nm": "Glow",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "tt": 1,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.788
                            },
                            "s": [
                                56,
                                440,
                                0
                            ],
                            "t": 94
                        },
                        {
                            "s": [
                                1416,
                                1228,
                                0
                            ],
                            "t": 140
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.643
                            },
                            "s": [
                                100
                            ],
                            "t": 110
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 140
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Shape 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 3,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            348.655,
                                            1.947
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            35.647,
                                            880.072
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -8.868,
                                            -0.049
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.819,
                                            -94.283
                                        ]
                                    ],
                                    "v": [
                                        [
                                            211.999,
                                            -440
                                        ],
                                        [
                                            -480,
                                            280
                                        ],
                                        [
                                            -136,
                                            648
                                        ],
                                        [
                                            483.999,
                                            -312
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.7882,
                                    0.8275,
                                    0.9373
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 30,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 3
        },
        {
            "ty": 4,
            "nm": "Background Circle (Blue)",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        346.917,
                        346.917,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "s": [
                                20,
                                20,
                                100
                            ],
                            "t": 30
                        },
                        {
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                110,
                                110,
                                100
                            ],
                            "t": 60
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                95,
                                95,
                                100
                            ],
                            "t": 80
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                102,
                                102,
                                100
                            ],
                            "t": 92
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                98,
                                98,
                                100
                            ],
                            "t": 100
                        },
                        {
                            "s": [
                                100,
                                100,
                                100
                            ],
                            "t": 110
                        }
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.506,
                                "y": 0
                            },
                            "i": {
                                "x": 0.783,
                                "y": 0.496
                            },
                            "s": [
                                1099.01,
                                1187.835,
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.337,
                                "y": 0.495
                            },
                            "i": {
                                "x": 0.576,
                                "y": 1
                            },
                            "s": [
                                989.155,
                                1114.015,
                                0
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                947.01,
                                981.835,
                                0
                            ],
                            "t": 50
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "s": [
                                100
                            ],
                            "t": 32
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ],
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ],
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            346.667
                                        ],
                                        [
                                            -346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            -346.666
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2627,
                                    0.3803,
                                    0.9333
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    346.916,
                                    346.917
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 4
        },
        {
            "ty": 4,
            "nm": "Background(Blue)",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        346.917,
                        346.917,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.67,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                100,
                                100,
                                100
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.67,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                148,
                                148,
                                100
                            ],
                            "t": 60
                        },
                        {
                            "s": [
                                88,
                                88,
                                100
                            ],
                            "t": 110
                        }
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                346.917,
                                346.917,
                                0
                            ],
                            "t": 30
                        },
                        {
                            "s": [
                                346.917,
                                346.917,
                                0
                            ],
                            "t": 49
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                20
                            ],
                            "t": 4
                        },
                        {
                            "s": [
                                20
                            ],
                            "t": 32
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ],
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            191.458
                                        ],
                                        [
                                            -191.458,
                                            0
                                        ],
                                        [
                                            0,
                                            -191.459
                                        ],
                                        [
                                            191.459,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            346.667
                                        ],
                                        [
                                            -346.667,
                                            0
                                        ],
                                        [
                                            0,
                                            -346.666
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2902,
                                    0.7608,
                                    0.6431
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    346.916,
                                    346.917
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 5,
            "parent": 4
        },
        {
            "ty": 4,
            "nm": "Element 11",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        88.379,
                        84.132,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.174,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1088.545,
                                1185.048,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                774.545,
                                1455.048,
                                0
                            ],
                            "t": 42
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": false,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -17.539,
                                            13.457
                                        ],
                                        [
                                            -12.743,
                                            -16.607
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -12.743,
                                            -16.608
                                        ],
                                        [
                                            17.539,
                                            -13.458
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -25.635,
                                            34.132
                                        ],
                                        [
                                            -16.894,
                                            -20.673
                                        ],
                                        [
                                            38.306,
                                            -14.931
                                        ],
                                        [
                                            38.379,
                                            -14.837
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "st",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Stroke",
                            "nm": "Stroke 1",
                            "lc": 2,
                            "lj": 2,
                            "ml": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 20,
                                "ix": 5
                            },
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4157,
                                    0.2784,
                                    0.6118
                                ],
                                "ix": 3
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    88.378,
                                    84.131
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 6
        },
        {
            "ty": 4,
            "nm": "Element 10",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        33.514,
                        41.664,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.229,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1088.113,
                                1187.051,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                1314.113,
                                1427.051,
                                0
                            ],
                            "t": 46
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            3.281,
                                            -1.895
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.894,
                                            3.281
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.281,
                                            1.894
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.894,
                                            -3.282
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.281,
                                            1.894
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.894,
                                            -3.283
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.281,
                                            -1.895
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.894,
                                            3.281
                                        ]
                                    ],
                                    "v": [
                                        [
                                            28.859,
                                            29.055
                                        ],
                                        [
                                            10.732,
                                            39.52
                                        ],
                                        [
                                            1.361,
                                            37.009
                                        ],
                                        [
                                            -31.37,
                                            -19.681
                                        ],
                                        [
                                            -28.859,
                                            -29.053
                                        ],
                                        [
                                            -10.732,
                                            -39.519
                                        ],
                                        [
                                            -1.361,
                                            -37.008
                                        ],
                                        [
                                            31.37,
                                            19.683
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2627,
                                    0.3803,
                                    0.9333
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    33.514,
                                    41.664
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 7
        },
        {
            "ty": 4,
            "nm": "Element 9",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        60.548,
                        78.82,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.189,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1106.768,
                                1189.936,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                1420.768,
                                1239.936,
                                0
                            ],
                            "t": 43
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": false,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.886,
                                            -21.917
                                        ],
                                        [
                                            20.753,
                                            2.734
                                        ],
                                        [
                                            0.039,
                                            0.005
                                        ]
                                    ],
                                    "o": [
                                        [
                                            20.754,
                                            2.733
                                        ],
                                        [
                                            -2.886,
                                            21.918
                                        ],
                                        [
                                            -0.04,
                                            -0.005
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -12.409,
                                            -41.32
                                        ],
                                        [
                                            20.162,
                                            3.615
                                        ],
                                        [
                                            -22.93,
                                            38.586
                                        ],
                                        [
                                            -23.048,
                                            38.571
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "st",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Stroke",
                            "nm": "Stroke 1",
                            "lc": 2,
                            "lj": 2,
                            "ml": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 15,
                                "ix": 5
                            },
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1451,
                                    0.9098,
                                    0.7137
                                ],
                                "ix": 3
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    60.548,
                                    78.82
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 8
        },
        {
            "ty": 4,
            "nm": "Element 8",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        47.326,
                        47.325,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.263,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1095.413,
                                1171.271,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                1397.413,
                                873.271,
                                0
                            ],
                            "t": 68
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            -11.644,
                                            -3.948
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.912,
                                            2.92
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.157,
                                            -12.294
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.985,
                                            -2.819
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            11.74,
                                            -3.65
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.449,
                                            -4.662
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            7.098,
                                            10.038
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.882,
                                            -0.063
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -7.354,
                                            9.853
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.569,
                                            4.624
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.623,
                                            1.568
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            9.854,
                                            -7.353
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.062,
                                            4.882
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            10.038,
                                            7.099
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -4.662,
                                            1.449
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.649,
                                            11.74
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.82,
                                            -3.986
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -12.293,
                                            0.156
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.92,
                                            -3.913
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.948,
                                            -11.644
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -17.558,
                                            -36.37
                                        ],
                                        [
                                            -13.481,
                                            -34.987
                                        ],
                                        [
                                            0.154,
                                            -37.147
                                        ],
                                        [
                                            3.606,
                                            -39.722
                                        ],
                                        [
                                            27.31,
                                            -27.644
                                        ],
                                        [
                                            27.255,
                                            -23.339
                                        ],
                                        [
                                            33.522,
                                            -11.038
                                        ],
                                        [
                                            37.038,
                                            -8.552
                                        ],
                                        [
                                            32.877,
                                            17.724
                                        ],
                                        [
                                            28.763,
                                            19.002
                                        ],
                                        [
                                            19.003,
                                            28.764
                                        ],
                                        [
                                            17.724,
                                            32.876
                                        ],
                                        [
                                            -8.551,
                                            37.037
                                        ],
                                        [
                                            -11.037,
                                            33.522
                                        ],
                                        [
                                            -23.338,
                                            27.255
                                        ],
                                        [
                                            -27.644,
                                            27.31
                                        ],
                                        [
                                            -39.721,
                                            3.606
                                        ],
                                        [
                                            -37.146,
                                            0.155
                                        ],
                                        [
                                            -34.987,
                                            -13.481
                                        ],
                                        [
                                            -36.37,
                                            -17.558
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4157,
                                    0.2784,
                                    0.6118
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    47.325,
                                    47.325
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 9
        },
        {
            "ty": 4,
            "nm": "Element 7",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        77.856,
                        74.774,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.229,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1086.148,
                                1173.839,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                1316.148,
                                645.839,
                                0
                            ],
                            "t": 46
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": false,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -12.731,
                                            9.768
                                        ],
                                        [
                                            -9.249,
                                            -12.055
                                        ],
                                        [
                                            -0.018,
                                            -0.022
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -9.249,
                                            -12.055
                                        ],
                                        [
                                            12.73,
                                            -9.768
                                        ],
                                        [
                                            0.018,
                                            0.023
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -18.607,
                                            24.774
                                        ],
                                        [
                                            -12.262,
                                            -15.006
                                        ],
                                        [
                                            27.805,
                                            -10.838
                                        ],
                                        [
                                            27.857,
                                            -10.77
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "st",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Stroke",
                            "nm": "Stroke 1",
                            "lc": 2,
                            "lj": 2,
                            "ml": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 20,
                                "ix": 5
                            },
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2627,
                                    0.3803,
                                    0.9333
                                ],
                                "ix": 3
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    77.856,
                                    74.774
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 10
        },
        {
            "ty": 4,
            "nm": "Element 6",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        47.326,
                        47.325,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.189,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1081.471,
                                1169.811,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                529.471,
                                1363.811,
                                0
                            ],
                            "t": 43
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            -11.644,
                                            -3.948
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.913,
                                            2.92
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.157,
                                            -12.294
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.986,
                                            -2.819
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            11.74,
                                            -3.65
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.449,
                                            -4.662
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            7.099,
                                            10.038
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.881,
                                            -0.062
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -7.353,
                                            9.853
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.568,
                                            4.624
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.623,
                                            1.567
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            9.853,
                                            -7.352
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.063,
                                            4.882
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            10.038,
                                            7.1
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -4.662,
                                            1.449
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.649,
                                            11.741
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.819,
                                            -3.987
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -12.293,
                                            0.157
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.92,
                                            -3.913
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.948,
                                            -11.644
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -17.558,
                                            -36.37
                                        ],
                                        [
                                            -13.481,
                                            -34.987
                                        ],
                                        [
                                            0.154,
                                            -37.147
                                        ],
                                        [
                                            3.605,
                                            -39.723
                                        ],
                                        [
                                            27.31,
                                            -27.644
                                        ],
                                        [
                                            27.255,
                                            -23.339
                                        ],
                                        [
                                            33.521,
                                            -11.038
                                        ],
                                        [
                                            37.037,
                                            -8.553
                                        ],
                                        [
                                            32.875,
                                            17.724
                                        ],
                                        [
                                            28.763,
                                            19.002
                                        ],
                                        [
                                            19.003,
                                            28.764
                                        ],
                                        [
                                            17.724,
                                            32.875
                                        ],
                                        [
                                            -8.552,
                                            37.037
                                        ],
                                        [
                                            -11.039,
                                            33.522
                                        ],
                                        [
                                            -23.339,
                                            27.254
                                        ],
                                        [
                                            -27.645,
                                            27.31
                                        ],
                                        [
                                            -39.722,
                                            3.606
                                        ],
                                        [
                                            -37.146,
                                            0.154
                                        ],
                                        [
                                            -34.987,
                                            -13.481
                                        ],
                                        [
                                            -36.37,
                                            -17.558
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2627,
                                    0.3803,
                                    0.9333
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    47.325,
                                    47.325
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 11
        },
        {
            "ty": 4,
            "nm": "Element 5",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        30.771,
                        30.771,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.283,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1071.297,
                                1171.159,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                517.297,
                                1177.159,
                                0
                            ],
                            "t": 70
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            -16.856
                                        ],
                                        [
                                            16.856,
                                            0
                                        ],
                                        [
                                            0,
                                            16.856
                                        ],
                                        [
                                            -16.857,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            16.856
                                        ],
                                        [
                                            -16.857,
                                            0
                                        ],
                                        [
                                            0,
                                            -16.856
                                        ],
                                        [
                                            16.856,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            30.521,
                                            0
                                        ],
                                        [
                                            0,
                                            30.521
                                        ],
                                        [
                                            -30.521,
                                            0
                                        ],
                                        [
                                            0,
                                            -30.521
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1451,
                                    0.9098,
                                    0.7137
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    30.771,
                                    30.771
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 12
        },
        {
            "ty": 4,
            "nm": "Element 4",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        42,
                        25.144,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.273,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1074.624,
                                1178.727,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                446.624,
                                934.727,
                                0
                            ],
                            "t": 69
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            -0.829,
                                            -3.697
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.698,
                                            -0.828
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.83,
                                            3.697
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.697,
                                            0.828
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.829,
                                            3.697
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.697,
                                            0.828
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.828,
                                            -3.697
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.697,
                                            -0.828
                                        ]
                                    ],
                                    "v": [
                                        [
                                            36.343,
                                            -18.872
                                        ],
                                        [
                                            40.921,
                                            1.552
                                        ],
                                        [
                                            35.727,
                                            9.747
                                        ],
                                        [
                                            -28.148,
                                            24.066
                                        ],
                                        [
                                            -36.344,
                                            18.872
                                        ],
                                        [
                                            -40.922,
                                            -1.553
                                        ],
                                        [
                                            -35.728,
                                            -9.747
                                        ],
                                        [
                                            28.148,
                                            -24.066
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.2627,
                                    0.3803,
                                    0.9333
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    42,
                                    25.144
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 13
        },
        {
            "ty": 4,
            "nm": "Element 3",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        47.326,
                        47.325,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.174,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1067.471,
                                1180.071,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                529.471,
                                736.071,
                                0
                            ],
                            "t": 61
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            -11.644,
                                            -3.948
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.913,
                                            2.92
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.157,
                                            -12.294
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.986,
                                            -2.819
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            11.74,
                                            -3.65
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.449,
                                            -4.662
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            7.099,
                                            10.038
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.881,
                                            -0.063
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -7.353,
                                            9.854
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.568,
                                            4.624
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.623,
                                            1.568
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            9.853,
                                            -7.353
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.063,
                                            4.882
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            10.038,
                                            7.099
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -4.662,
                                            1.449
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.649,
                                            11.74
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.819,
                                            -3.986
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -12.293,
                                            0.157
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.92,
                                            -3.912
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.948,
                                            -11.644
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -17.558,
                                            -36.37
                                        ],
                                        [
                                            -13.481,
                                            -34.987
                                        ],
                                        [
                                            0.154,
                                            -37.147
                                        ],
                                        [
                                            3.605,
                                            -39.722
                                        ],
                                        [
                                            27.31,
                                            -27.644
                                        ],
                                        [
                                            27.255,
                                            -23.339
                                        ],
                                        [
                                            33.521,
                                            -11.038
                                        ],
                                        [
                                            37.037,
                                            -8.552
                                        ],
                                        [
                                            32.875,
                                            17.724
                                        ],
                                        [
                                            28.763,
                                            19.002
                                        ],
                                        [
                                            19.003,
                                            28.764
                                        ],
                                        [
                                            17.724,
                                            32.876
                                        ],
                                        [
                                            -8.552,
                                            37.037
                                        ],
                                        [
                                            -11.039,
                                            33.522
                                        ],
                                        [
                                            -23.339,
                                            27.255
                                        ],
                                        [
                                            -27.645,
                                            27.309
                                        ],
                                        [
                                            -39.722,
                                            3.605
                                        ],
                                        [
                                            -37.146,
                                            0.154
                                        ],
                                        [
                                            -34.987,
                                            -13.481
                                        ],
                                        [
                                            -36.37,
                                            -17.558
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.1922,
                                    0.4392,
                                    0.702
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    47.325,
                                    47.325
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 14
        },
        {
            "ty": 4,
            "nm": "Element 2",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        33.515,
                        41.664,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.292,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1098.638,
                                1189.457,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                788.638,
                                547.457,
                                0
                            ],
                            "t": 71
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 1
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.72,
                                "y": 0
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.601
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            3.281,
                                            -1.895
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.895,
                                            3.281
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.281,
                                            1.894
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.895,
                                            -3.281
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.282,
                                            1.895
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.895,
                                            -3.281
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.281,
                                            -1.894
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.895,
                                            3.282
                                        ]
                                    ],
                                    "v": [
                                        [
                                            28.859,
                                            29.054
                                        ],
                                        [
                                            10.733,
                                            39.519
                                        ],
                                        [
                                            1.36,
                                            37.008
                                        ],
                                        [
                                            -31.37,
                                            -19.683
                                        ],
                                        [
                                            -28.859,
                                            -29.054
                                        ],
                                        [
                                            -10.732,
                                            -39.52
                                        ],
                                        [
                                            -1.36,
                                            -37.009
                                        ],
                                        [
                                            31.37,
                                            19.682
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4157,
                                    0.2784,
                                    0.6118
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    33.515,
                                    41.664
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 15
        },
        {
            "ty": 4,
            "nm": "Element 1",
            "sr": 1,
            "st": 0,
            "op": 1800,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        30.771,
                        30.771,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                },
                "sk": {
                    "a": 0,
                    "k": 0
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.252,
                                "y": 0
                            },
                            "i": {
                                "x": 0.33,
                                "y": 1
                            },
                            "s": [
                                1087.199,
                                1174.507,
                                0
                            ],
                            "t": 10
                        },
                        {
                            "s": [
                                1027.199,
                                504.507,
                                0
                            ],
                            "t": 67
                        }
                    ],
                    "ix": 2
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                0
                            ],
                            "t": 0
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                100
                            ],
                            "t": 4
                        },
                        {
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "s": [
                                100
                            ],
                            "t": 32
                        },
                        {
                            "s": [
                                0
                            ],
                            "t": 87
                        }
                    ],
                    "ix": 11
                }
            },
            "ef": [],
            "shapes": [
                {
                    "ty": "gr",
                    "bm": 0,
                    "hd": false,
                    "mn": "ADBE Vector Group",
                    "nm": "Group 1",
                    "ix": 1,
                    "cix": 2,
                    "np": 2,
                    "it": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Shape - Group",
                            "nm": "Path 1",
                            "ix": 1,
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            -16.856
                                        ],
                                        [
                                            16.856,
                                            0
                                        ],
                                        [
                                            0,
                                            16.857
                                        ],
                                        [
                                            -16.857,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            16.857
                                        ],
                                        [
                                            -16.857,
                                            0
                                        ],
                                        [
                                            0,
                                            -16.856
                                        ],
                                        [
                                            16.856,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            30.522,
                                            -0.001
                                        ],
                                        [
                                            0,
                                            30.522
                                        ],
                                        [
                                            -30.522,
                                            -0.001
                                        ],
                                        [
                                            0,
                                            -30.522
                                        ]
                                    ]
                                },
                                "ix": 2
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "mn": "ADBE Vector Graphic - Fill",
                            "nm": "Fill 1",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.4157,
                                    0.2784,
                                    0.6118
                                ],
                                "ix": 4
                            },
                            "r": 1,
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": "tr",
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    30.771,
                                    30.772
                                ],
                                "ix": 2
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            }
                        }
                    ]
                }
            ],
            "ind": 16
        }
    ],
    "v": "5.5.7",
    "fr": 60,
    "op": 180,
    "ip": 0,
    "assets": []
}